<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{ innerText?: string; index?: number }>(),
  {
    innerText: '大标题'
  }
);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="40" viewBox="0 0 1024 31">
  <g id="xiaobiao3" transform="translate(0 -9)">
    <g id="椭圆_824" data-name="椭圆 824" transform="translate(15 9)" fill="none" stroke="var(--theme-color-1)" stroke-width="2">
      <circle cx="15.5" cy="15.5" r="15.5" stroke="none"/>
      <circle cx="15.5" cy="15.5" r="14.5" fill="none"/>
    </g>
    <circle id="椭圆_823" data-name="椭圆 823" cx="15.5" cy="15.5" r="15.5" transform="translate(0 9)" fill="var(--theme-color-1)"/>
    <text id="项目执行人性别分布" transform="translate(62 33)" fill="#222" font-size="22" font-weight="600" letter-spacing="0.09em"><tspan x="0" y="0">${props.innerText}</tspan></text>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped></style>
